export const authenticatedRoutes = {
  Accreditation: '/account/accreditation',
  Communications: '/account/communications',
  Documents: '/account/documents',
  Help: '/account/help',
  Invest: '/account/invest',
  InvestAmount: '/account/invest/amount',
  InvestConfirmation: '/account/invest/confirmation',
  InvestDocuments: '/account/invest/documents',
  InvestPayment: '/account/invest/payment',
  InvestReview: '/account/invest/review',
  InvestVerifyId: '/account/invest/verify-id',
  Overview: '/account/overview',
  Settings: '/account/settings',
  Wallet: '/account/wallet',
};

export const unauthenticatedRoutes = {
  Auth: '/auth',
  root: '/',
};

export const onboardingRoutes = {
  Onboarding: '/onboarding',
  OnboardingAccreditedInvestor: '/onboarding/accredited-investor',
  OnboardingAddEntityContactInfo: '/onboarding/add-entity-contact-info',
  OnboardingAddEntityDetails: '/onboarding/add-entity-details',
  OnboardingClaimVerifyIdentity: '/onboarding/claim-verify-identity',
  OnboardingCreateAccount: '/onboarding/create-account',
  OnboardingGetStarted: '/onboarding/get-started',
  OnboardingSelectEntityType: '/onboarding/select-entity-type',
  OnboardingVerifyEmail: '/onboarding/verify-email',
  OnboardingVerifyIdentity: '/onboarding/verify-identity',
  OnboardingVerifyInformation: '/onboarding/verify-information',
  OnboardingWelcomeComplete: '/onboarding/complete',
};

export const gromaCoinRoutes = {
  GromaCoinRoot: '/gromacoin',
  GromaCoinWelcome: '/gromacoin',
  GromaCoinClaim: '/gromacoin/claim/:claimId',
  GromaCoinTransaction: '/gromacoin/transaction',
  GromaCoinNextSteps: '/gromacoin/next-steps',
  GromaCoinVerify: '/gromacoin/verify',
  GromaCoinWaitlist: '/gromacoin/waitlist',
};

export const AppRoutes = {
  ...authenticatedRoutes,
  ...unauthenticatedRoutes,
  ...onboardingRoutes,
  ...gromaCoinRoutes,
};
